import React from "react";
import { Box, Grid, Typography, Stack, IconButton, } from "@mui/material";
import { InstagramEmbed, FacebookEmbed } from "react-social-media-embed";
import FacebookIcon from "@mui/icons-material/FacebookOutlined";
import InstagramInIcon from "@mui/icons-material/Instagram";
import imagenBackground from "../../assets/Home/Banner_socialmedia.png";

const SocialMedia = () => {
  return (
    <Box sx={{
      backgroundPositionX: {xs: "-600px", sm:"0"},
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${imagenBackground})`,
      p: "42px 20px",
      backgroundColor: "#3960ED",
      display:{sm:"block", md:"flex"},
      justifyContent: "center",
    }}>

      <Box sx={{width:{sm:"100%", md:"25%", lg:"30%"}, alignSelf: "center"}}>
        <Typography variant="h1" sx={{
          textAlign: "center", 
          fontSize:{xs:"34px", md:"36px", lg:"50px"}, 
          minWidth: "250px",
          padding:"18px 16px 12px 12px",
          color:"white",
        }}>
          CONOCENOS EN NUESTRAS REDES SOCIALES
        </Typography>
        <Stack
          direction="row"
          justifyContent="center"
          spacing={1}
          useFlexGap
          sx={{
            color: "secondary",
            padding:"0 0 15px 0"
          }}
        >
          <IconButton
            color="inherit"
            href="https://www.facebook.com/SanRafaelCQ"
            aria-label="facebook"
            sx={{ alignSelf: "center", transition:"all 0.4s ease-in-out", "&:hover": {color: "white"} }}
          >
            <FacebookIcon sx={{fontSize:"50px"}} />
          </IconButton>
          <IconButton
            color="inherit"
            href="https://www.instagram.com/sanrafaelcq/"
            aria-label="instagram"
            sx={{ alignSelf: "center", transition:"all 0.4s ease-in-out", "&:hover": {color: "white"} }}
          >
            <InstagramInIcon sx={{fontSize:"50px"}}  />
          </IconButton>
        </Stack>
      </Box>

      <Box sx={{width:{sm:"100%", md:"8%", lg:"2%"}, }} />

      <Box sx={{ 
        width:{xs:"100%", md:"67%", lg:"68%"}, 
        maxWidth:{xs:"365px", md:"700px"},
        display:{sm:"block", md:"flex"}, 
        padding:"20px 12px",
        borderRadius:"18px",
        justifyItems:"center",
        justifySelf: "center",
        bgcolor:"secondary.highlight",
      }}>

        {/* FACEBOOK - IZQUIERDA */}
        <Box sx={{ width:{xs:"100%"}, mb:"12px"}}>
          <FacebookEmbed
            url="https://www.facebook.com/story.php?story_fbid=1535680585256277&id=100064430510077&rdid=1OFJnIJlvOHevs9q#"
            width="100%"
          />
        </Box>

        <Box sx={{padding:"6px"}} />

        {/* INSTAGRAMS - DERECHA */}
        {/* <Box sx={{width:{xs:"100%", sm:"70%", md:"50%"}, minWidth:"326px"}}>
          <Box sx={{width:{xs:"100%", sm:"100%", md:"100%"} }}>
            <InstagramEmbed
              url="https://www.instagram.com/p/DXiRJE2juA_/"
              width="100%"
            />
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
};

export default SocialMedia;